import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import api from "../lib/api";

const ABOUT_IMG = "https://images.unsplash.com/photo-1633665503034-78f3628a86e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHxfHx0cnVjayUyMGRyaXZlciUyMHBvcnRyYWl0JTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4ODg5NzUxM3ww&ixlib=rb-4.1.0&q=85";

export default function About() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data.content)).catch(() => {});
  }, []);

  return (
    <div className="bg-[#0B132B]" data-testid="about-page">
      <section className="py-16 lg:py-24 bg-[#0f1830] border-b border-[#1E293B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono2 text-xs uppercase tracking-widest text-[#F97316] mb-3">About Us</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight leading-none max-w-3xl" data-testid="about-title">
            {content?.about_title || "A Partner Dedicated to Your Trucking Success"}
          </h1>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-14 items-start">
        <div>
          <img src={ABOUT_IMG} alt="Professional truck driver" data-testid="about-image"
            className="w-full h-80 lg:h-[480px] object-cover rounded-lg border border-[#1E293B]" />
          <div className="mt-6 flex items-center gap-3 border border-[#1E293B] bg-[#131C38] rounded-lg px-5 py-4">
            <MapPin className="w-5 h-5 text-[#F97316] shrink-0" />
            <p className="text-sm text-slate-300" data-testid="about-coverage">
              Nationwide coverage — serving carriers in all 50 states with remote filings and phone support.
            </p>
          </div>
        </div>
        <div className="space-y-5" data-testid="about-text">
          {(content?.about_text || "").split(/\n+/).filter(Boolean).map((p, i) => (
            <p key={i} className="text-slate-300 text-sm sm:text-base leading-relaxed">{p}</p>
          ))}
          <div className="pt-4">
            <Link to="/contact" data-testid="about-cta-btn"
              className="inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#EA580C] text-[#0B132B] font-bold text-sm px-7 py-3.5 rounded-md transition-colors">
              Work With Us <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
      {(content?.why_choose_us || []).length > 0 && (
        <section className="py-16 bg-[#0f1830] border-t border-[#1E293B]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-white tracking-tight mb-10">Why Choose Crystal Logistics</h2>
            <div className="grid sm:grid-cols-2 gap-5">
              {content.why_choose_us.map((w, i) => (
                <div key={i} className="bg-[#131C38] border border-[#1E293B] rounded-lg p-7" data-testid={`about-why-${i}`}>
                  <h3 className="font-display text-xl font-semibold text-white mb-2">{w.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{w.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
